import { computed, ref, watch } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import useStaff from './useStaff';

const useStaffList = () => {
  const toast = useToast();
  const { getListStaff } = useStaff();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'firstname', sortable: true },
    { key: 'lastname', sortable: true },
    { key: 'actions' },
  ];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refStaffListTable = ref(null);
  const searchQuery = ref(null);
  const orderBy = ref('id');
  const totalStaff = ref(0);

  const dataMeta = computed(() => {
    const localItemsCount = refStaffListTable.value
      ? refStaffListTable.value.localItems.length
      : 0;
    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalStaff.value,
    };
  });

  watch([pageNumber, pageSize], () => {
    refStaffListTable.value.refresh();
  });

  const getStaffList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      searchQuery: searchQuery.value,
    };

    getListStaff(params).then(({ staff, total }) => {
      callback(staff);
      totalStaff.value = total;
    });
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    pageNumber,
    orderDesc,
    pageSize,
    refStaffListTable,
    searchQuery,
    orderBy,
    totalStaff,

    // Computed
    dataMeta,

    // Method
    getStaffList,
  };
};

export default useStaffList;
